import { ICommandHandler } from '@withlocals/cqrs.js/lib';
import { AccountApi } from 'aggregates/account/client';
import {
  AccountUpdated,
  RefreshAccount,
  UpdateAccount,
} from 'aggregates/account/commands';
import { Observable } from 'rxjs/Observable';

import { AuthenticationInfo } from '../../model/AuthenticationInfo';

export const accountMessageHandlerFactory = (
  authInfo: AuthenticationInfo,
): ICommandHandler => {
  const apiClient = new AccountApi(authInfo);
  return (command) => {
    if (command instanceof UpdateAccount) {
      return apiClient
        .updateAccount(command.data)
        .map(() => new AccountUpdated(authInfo.accountId));
    }
    if (command instanceof RefreshAccount) {
      return Observable.of(new AccountUpdated(authInfo.accountId));
    }
    return null;
  };
};
